import { render, staticRenderFns } from "./NotificationItemCard.vue?vue&type=template&id=17739b0f&scoped=true&"
import script from "./NotificationItemCard.vue?vue&type=script&lang=js&"
export * from "./NotificationItemCard.vue?vue&type=script&lang=js&"
import style0 from "./NotificationItemCard.vue?vue&type=style&index=0&id=17739b0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17739b0f",
  null
  
)

export default component.exports